import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  unlinkCategoriesLength: 0,
  unlinkCategories: [],
  unlinkCategoriesError: "",
  formError: "",
};

export default function UnlinkCategoriesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_UNLINK_CATEGORIES:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_UNLINK_CATEGORIES:
      return { ...state, saveLoading: action.payload };
    case actions.GET_UNLINK_CATEGORIES:
      return {
        ...state,
        unlinkCategories: action.payload.unlinkCategories,
        unlinkCategoriesLength: action.payload.unlinkCategoriesLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.UNLINK_CATEGORIES_FAIL:
      return { ...state, unlinkCategoriesError: action.payload };
    default:
      return state;
  }
}
